'use client';
import styles from 'styles/CTABanner.module.scss';
import { useAppSelector } from 'lib/hooks';
import CaretIcon from './icons/CaretIcon';
import UIButton from './buttons/UIButton';
import { selectHasRecommendation } from 'slices/selectors';
import { captureConversationStarted } from 'lib/analytics';

const CTASideAd = () => {
  const hasRecommendation = useAppSelector((state) =>
    selectHasRecommendation(state)
  );
  if (hasRecommendation) {
    return null;
  }

  return (
    <div className={styles.ctaSideAd}>
      <h4>
        Not sure where<br></br>to start?
      </h4>
      <p>
        With a few questions and 25 minutes, <b>ALEX</b> turns Medicare
        confusion into clarity.
      </p>
      <UIButton
        buttonType="tertiary"
        label="Recommend me a plan"
        icon={<CaretIcon direction="right" size="large" />}
        href="/check-audio"
        className={styles.getRecBtn}
        onClick={() => captureConversationStarted('cta_side_ad')}
      />
    </div>
  );
};

export default CTASideAd;
